"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DrivingDirectionsOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M21.82,15.47a.7.7,0,0,0,0-.94l-3.66-4.19a1,1,0,0,0-1.4-.09,1,1,0,0,0-.08,1.41l2,2.34H11.39A1.39,1.39,0,0,0,10,15.39V18a1,1,0,0,0,1,1,1,1,0,0,0,1-1V16h6.72l-2,2.34A1,1,0,0,0,17.42,20a1,1,0,0,0,.74-.34Z"/><path d="M16,4h0L28,16,16,28,4,16,16,4h0m0-2a2,2,0,0,0-1.4.58l-12,12a2,2,0,0,0,0,2.8l12,12a2,2,0,0,0,2.8,0l12-12a2,2,0,0,0,0-2.8l-12-12A2,2,0,0,0,16,2Z"/>';
var DrivingDirectionsOutlineSVG = function DrivingDirectionsOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.DrivingDirectionsOutlineSVG = DrivingDirectionsOutlineSVG;
DrivingDirectionsOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(DrivingDirectionsOutlineSVG);
exports.default = _default;